import './shape.css';
import { h } from 'preact';

export default function Shape({ id, status, isSelected, isHighlighted, handleClick, elementTagName, points, d, width, height, x, y }) {
	function onClick(event) {
		event.preventDefault();
		event.stopPropagation();
		if (typeof handleClick === 'function') {
			handleClick(id);
		}
	}

	function getSvgElement() {
		switch (elementTagName) {
		case 'polygon':
			return <polygon class="shape" points={points} />;
		case 'path':
			return <path class="shape" d={d} />;
		case 'rect':
			return <rect class="shape" height={height} width={width} x={x} y={y} />;
		}
	}

	return (
		<a key={id} id={id} onClick={onClick} xlinkHref="#" class={'shape-container status-' + status + (isSelected ? ' is-selected' : '') + (isHighlighted ? ' is-highlighted' : '')}>
			{getSvgElement()}
		</a>
	);
}
